"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MentionTargetType = exports.ConversationParticipantRole = exports.ConversationType = exports.ConversationStatus = exports.MessageType = void 0;
var MessageType;
(function (MessageType) {
    MessageType["AI_MESSAGE"] = "aiMessage";
    MessageType["CHARACTER_PHOTOS_UPLOADED"] = "characterPhotosUploaded";
    MessageType["ERROR_MESSAGE"] = "errorMessage";
    MessageType["NEW_CONVERSATION"] = "newConversation";
    MessageType["NOTIFICATION"] = "notification";
    MessageType["PERFORMER_CONTRACT_DECLINED"] = "performerContractDeclined";
    MessageType["SUPPORT_MESSAGE"] = "supportMessage";
    MessageType["SYSTEM_MESSAGE"] = "systemMessage";
    /** Ephemeral typing-indicator ping — never persisted as a ChatMessage row. */
    MessageType["TYPING"] = "typing";
    MessageType["UPDATED_CONVERSATION"] = "updatedConversation";
    MessageType["USER_MESSAGE"] = "userMessage";
})(MessageType || (exports.MessageType = MessageType = {}));
var ConversationStatus;
(function (ConversationStatus) {
    ConversationStatus["OPEN"] = "open";
    ConversationStatus["CLOSED"] = "closed";
})(ConversationStatus || (exports.ConversationStatus = ConversationStatus = {}));
var ConversationType;
(function (ConversationType) {
    ConversationType["SUPPORT"] = "support";
    ConversationType["TALENT_MANAGER"] = "talentManager";
    ConversationType["PROJECT"] = "project";
})(ConversationType || (exports.ConversationType = ConversationType = {}));
var ConversationParticipantRole;
(function (ConversationParticipantRole) {
    ConversationParticipantRole["AGENCY"] = "agency";
    ConversationParticipantRole["TALENT_MANAGER"] = "talentManager";
    ConversationParticipantRole["SUPPORT"] = "support";
    ConversationParticipantRole["ADMIN_OBSERVER"] = "adminObserver";
})(ConversationParticipantRole || (exports.ConversationParticipantRole = ConversationParticipantRole = {}));
var MentionTargetType;
(function (MentionTargetType) {
    MentionTargetType["USER"] = "user";
    MentionTargetType["BOT"] = "bot";
    MentionTargetType["SUPPORT"] = "support";
})(MentionTargetType || (exports.MentionTargetType = MentionTargetType = {}));
//# sourceMappingURL=chat-types.js.map